import { useQuery } from '@tanstack/react-query';
import { getIntegratedScrapeStatus } from '~apis/scrape';

type ScrapeStatusResponse = Awaited<ReturnType<typeof getIntegratedScrapeStatus>>;

export const IntegratedScrapeQueryStatusKeys = {
  default: () => ['integrated-scrape-status'] as const,
  scrapeStatus: (companyId: string) =>
    [...IntegratedScrapeQueryStatusKeys.default(), companyId] as const,
};

export default function useGetIntegratedScrapeStatus<TData = ScrapeStatusResponse>(
  companyId: string,
  options?: { select?: (data: ScrapeStatusResponse) => TData },
) {
  return useQuery({
    queryKey: IntegratedScrapeQueryStatusKeys.scrapeStatus(companyId),
    queryFn: () => getIntegratedScrapeStatus(companyId),
    enabled: !!companyId,
    ...options,
  });
}
